import { render, staticRenderFns } from "./telCenter.vue?vue&type=template&id=39ecf5de&scoped=true"
import script from "./telCenter.vue?vue&type=script&lang=js"
export * from "./telCenter.vue?vue&type=script&lang=js"
import style0 from "./telCenter.vue?vue&type=style&index=0&id=39ecf5de&prod&lang=css"
import style1 from "./telCenter.vue?vue&type=style&index=1&id=39ecf5de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ecf5de",
  null
  
)

export default component.exports